import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["stepsList"]

  connect() {
    if (this.hasStepsListTarget) {
      this.sortable = Sortable.create(this.stepsListTarget, {
        group: "workflow_steps_list_group",
        handle: ".drag-handle",
        animation: 150,
        ghostClass: "!bg-blue-200",
        onEnd: this.onEnd.bind(this)
      })
    } else {
      console.error("No stepsList target found")
    }
  }

  onEnd(event) {
    const stepId = event.item.dataset.stepId
    if (!stepId) {
      console.error('No step ID found on dragged item')
      return
    }

    const newPosition = event.newIndex
    const oldPosition = event.oldIndex
    const reorderUrl = event.item.dataset.reorderUrl

    // console.log("Reordering step", { stepId, newPosition, oldPosition, reorderUrl })

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    fetch(`${reorderUrl}?new_position=${newPosition}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json()
    })
    .then(data => {
      if (data.success) {
      } else {
        throw new Error(data.error || 'Failed to reorder step')
      }
    })
    .catch(error => {
      console.error('Error:', error)
      alert('Failed to save the new order. Please try again.')
      // Revert the sort to the previous position
      this.sortable.sort(this.sortable.toArray())
    })
  }
}
